import React from 'react';

import correoEnviadoIcon from '../../../images/icons/correo-electronico.png';
import correoAbiertoIcon from '../../../images/icons/sobre-abierto-con-carta.png';

function ModalJJVV({ closeModal }) {
    return (
        <div
                                id={'LeyendaJefeVentas'}
                                style={{ display: 'none' }}
                            >
                                <div className="u-1/1">
                                    <div className="u-1/6 u-float-left">
                                        <img src={correoEnviadoIcon} style={{ height: "35px" }}></img>
                                    </div>
                                    <div className="u-5/6">
                                        Correo enviado a jefe de ventas de un potencial cliente
                                    </div>
                                </div>
                                <div className="u-1/1">
                                    <div className="u-1/6 u-float-left">
                                    <img src={correoAbiertoIcon} style={{ height: "35px" }}></img>
                                    </div>
                                    <div className="u-5/6">
                                        Correo enviado con anterioridad ha sido abierto por el jefe de ventas
                                    </div>
                                </div>
                            </div>
    );
}

export default ModalJJVV;
